import { Cryptocurrency } from "../../types/assets";
import api from "../api";

export const getCryptocurrencies = async (): Promise<{
  data: Cryptocurrency[];
}> => {
  const { data } = await api.get("/v2/cryptocurrencies/");
  return data;
};
